'use strict';

angular.module('licensure.services')
    .factory('DataChangeLog', ['$http', '$q', function ($http, $q) {

        return {
            get: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/DataChangeLog', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getServiceLocations: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/DataChangeLog/ServiceLocations', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getTriggerConfigurationLog: function (args) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/TriggerConfigurationTriggerChangeLog', {
                    params: args
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            }
        }
    }])
;